import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import colors from '../../styles/colors';

export interface Props {
  title?: string | JSX.Element;
  className?: string;
}

class StackedList extends React.Component<Props, {}> {
  render() {
    const { className, children, title } = this.props;
    return (
      <section className={className}>
        <div className="title">{title}</div>
        <div className="content">{children}</div>
      </section>
    );
  }
}

const StyledStackedList: StyledComponentClass<Props, {}> = styled(StackedList)`
  display: flex;
  flex-flow: column nowrap;
  max-width: 960px;

  & > .title {
    width: 100%;
    text-align: center;
    font-size: 1rem;
    margin-bottom: 16px;
  }

  & > .content {
    display: flex;
    flex-flow: column nowrap;
    border: 1px solid ${colors.grey300};
    border-radius: 8px;
  }
`;

export default StyledStackedList;
